import type {
  WrapUpTimeStartedRequest,
  WrapUpTimeStartedEventPublisher,
} from '@usecases/wrap-up-time-started.usecase';
import { publishEvent } from '@salesforce/scv-connector-base';
import { Logger } from '@main/utils/logger';
import { Constants } from '@salesforce/scv-connector-base';
import { ScvObjectManager } from '@main/sf-connector/scv-object-manager';

export class WrapUpTimeStartedPublisher
  implements WrapUpTimeStartedEventPublisher
{
  private logger: Logger;
  constructor() {
    this.logger = new Logger();
  }
  async publish(call: WrapUpTimeStartedRequest): Promise<void> {
    this.logger.info('Publisher: Wrap Up Time Started', {
      action: 'WrapUpTimeStarted',
      mandatoryTaggingRequired: Boolean(call.mandatoryTaggingRequired),
    });
    setTimeout(() => {
      publishEvent({
        eventType: Constants.VOICE_EVENT_TYPE.AFTER_CALL_WORK_STARTED,
        payload: { callId: call.Id },
        registerLog: false,
      });
    }, 0);

    // Prompt the widget early when the agent's number requires tagging, so the
    // call-ended screen can mark tagging mandatory and block its submit.
    if (call.mandatoryTaggingRequired) {
      ScvObjectManager.notifyScv({
        type: 'SCV.MANDATORY_TAGGING_REQUIRED',
        data: { callId: call.Id },
      });
    }
  }
}
